import { bigQuery } from '@fiverr-private/obs';

export const sendBigQueryEvent = (eventPayload) => {
    bigQuery.send(eventPayload);
};
